import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeModule } from '../@core/pipes/pipe-modules/safe.module';
import { HttpClientModule } from '@angular/common/http';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    MatSidenavModule,
    MatListModule,
    MatSnackBarModule,
    MatIconModule,
    MatDialogModule,
    SafeModule.forRoot()
  ],
  exports: [
    MatListModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatIconModule
  ],
})
export class SharedComponentsPublicAPPModule { }
